module.exports = __webpack_public_path__ + "img/growth.01b05f98.png";